export const STORAGE = {
  LANGUAGE: 'LANGUAGE',
  USER_TOKEN: 'USER_TOKEN',
  USER_NAME: 'USER_NAME',
  USER_EMAIL: 'USER_EMAIL',
  DRIVE_TOKEN: 'DRIVE_TOKEN',
  META_DATA: 'META_DATA',
  ROLE: 'ROLE',
  PLAN: 'PLAN',
  FAEnabled: 'ENABLE_2FA',
  IS_CHECK2FA: 'IS_CHECK2FA',
  EMAIL_CHANGE: 'EMAIL_CHANGE',
  EMAIL_CHANGE_VERIFY: 'EMAIL_CHANGE_VERIFY',
  USER_LOGIN: 'USER_LOGIN',
  NOT_AUTHENTICATED_ERROR: 'NOT_AUTHENTICATED_ERROR'
}

export const LOGIN_MODE = {
  LABEL: 'LOGIN_MODE',
  BASIC: 'BASIC',
  GOOGLE: 'GOOGLE',
  MS: 'MS'
}

export function getLocalStorage(key) {
  return localStorage.getItem(key)
}

export function setLocalStorage(key, value) {
  return localStorage.setItem(key, value)
}

export function removeLocalStorage(key) {
  return localStorage.removeItem(key)
}

export function clearLocalStorage() {
  return localStorage.clear()
}
